import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as services from '../../services'
import { showErrorToast } from '../../state/toasts'
import {DashboardCardSkeleton} from './DashboardCardSkeleton'
import {DashboardCard} from './DashboardCard'
import {RootState} from "../../state/reducer";

const DashboardCounts = (props) => {
  const dispatch = useDispatch()
  const [counts, setCounts] = useState(null)
  const { user } = useSelector((state:RootState) => state.auth)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    new services.UserService(user.url)
      .getUserDashboard()
      .then((response) => {
        if (response.result.counts) {
          setCounts(response.result.counts)
        } else {
          setCounts(null)
        }
        setLoading(false)
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
        setLoading(false)
      })
  }, [user, dispatch])

  const cards = []

  if (!loading && counts) {
    for (const card in counts) {
      if (counts[card].order !== 3) {
        cards.push(
          <DashboardCard
            key={counts[card].heading}
            heading={counts[card].heading}
            value={counts[card].value}
            order={counts[card].order}
          />
        )
      }
    }
  }

  return (
    <div
      className={"wrapper"}
    >
        {loading
            ? Array.from({length: 7}).map((_, index) => <DashboardCardSkeleton key={index}/>)
            :
                cards
            }
    </div>
  )
}

export default DashboardCounts
